export default "__VITE_ASSET__8wzXF96D__"